import React, { ReactElement } from 'react';

//Components
import NodeAssetsForm from './NodeAssetsForm';

// Interfaces
import { NodeInfo } from '../../Interfaces/Assets/AssetInfo';

interface Props {
  isPageOpened: boolean;
  handleClosePage: (open: boolean) => void;
  assetData: NodeInfo;
}

const NodeAssets: React.FC<Props> = ({
  isPageOpened,
  handleClosePage,
  assetData,
}): ReactElement => {
  const handleClose = () => {
    handleClosePage(false);
  };

  return (
    <div>
      {isPageOpened ? (
        <NodeAssetsForm assetData={assetData} closePage={handleClose} />
      ) : null}
    </div>
  );
};

export default NodeAssets;
